import { NavLink } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useHealth, useRegime, useStatus } from '../../hooks/useQualyz'
import { datumVorTagen, formatDatum } from '../../lib/lenses'
import { regimeAnzeige } from '../../lib/regime'
import { NAVIGATION } from './navigation'

interface Props {
  offen: boolean
  onNavigate: () => void
}

export default function Sidebar({ offen, onNavigate }: Props) {
  const { isAdmin, isAuthenticated } = useAuth()
  const regime = useRegime()
  const health = useHealth()
  const status = useStatus()

  const gruppen = NAVIGATION.map((g) => ({
    ...g,
    punkte: g.punkte.filter((p) => (!p.nurAdmin || isAdmin) && (!p.nurAngemeldet || isAuthenticated)),
  })).filter((g) => g.punkte.length > 0)

  const anzeige = regime.data ? regimeAnzeige(regime.data.regime) : null

  // Kursstand: exakt aus /api/status, sonst aus dem Datenalter von /health.
  const tageAlt = health.data?.daten?.kurse_tage_alt
  const kurse = status.data?.kurse_stand
    ? formatDatum(status.data.kurse_stand)
    : typeof tageAlt === 'number'
      ? formatDatum(datumVorTagen(tageAlt))
      : '–'
  const veraltet = status.data?.kurse_veraltet ?? health.data?.daten?.veraltet ?? false

  return (
    <aside id="q-sidebar" className={`q-sidebar${offen ? ' is-open' : ''}`} aria-label="Hauptnavigation">
      <div className="q-side-brand">
        <NavLink to="/" className="q-wordmark" onClick={onNavigate}>
          Qualyz
        </NavLink>
      </div>

      <nav className="q-nav">
        {gruppen.map((gruppe) => (
          <div key={gruppe.titel}>
            <div className="q-navgroup">{gruppe.titel}</div>
            {gruppe.punkte.map((punkt) => {
              const Icon = punkt.icon
              return (
                <NavLink key={punkt.to} to={punkt.to} end={punkt.ende} className="q-navitem" onClick={onNavigate}>
                  <Icon className="q-navicon" aria-hidden="true" />
                  <span>{punkt.label}</span>
                </NavLink>
              )
            })}
          </div>
        ))}
      </nav>

      <div className="q-side-status">
        <div className="q-side-label">Status</div>
        <div className="q-side-regime">
          <span className={`q-dot q-dot--${anzeige?.ton ?? 'neutral'}`} aria-hidden="true" />
          Regime <b>{anzeige?.kurz ?? '–'}</b>
        </div>
        <div className="q-side-row">
          <span>Kurse</span>
          <span
            className={`q-mono${veraltet ? ' is-warn' : ''}`}
            title={veraltet ? health.data?.daten?.hinweis ?? 'Kursdaten sind veraltet.' : undefined}
          >
            {kurse}
          </span>
        </div>
      </div>
    </aside>
  )
}
